import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-x-18 gap-y-10" }

import {
    LabelWithNamedArguments,
} from '@/types/productServerApi';
import CustomizerMiniButton from '@/shared/product/customizer/ui/CustomizerMiniButton.vue';
import BlockLabelWithNamedArguments from '@/shared/BlockLabelWithNamedArguments.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomizerMiniTabDefault',
  props: {
    id: null,
    title: { default: undefined },
    description: { default: undefined },
    action: { default: undefined }
  },
  emits: ["action"],
  setup(__props: any, { emit }: { emit: ({(e: 'action');}), expose: any, slots: any, attrs: any }) {






const handleClick = () => {
    emit('action');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "o-anim-fade-200",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.description)
          ? (_openBlock(), _createElementBlock("div", { key: __props.description }, _toDisplayString(__props.description), 1))
          : _createCommentVNode("", true),
        (__props.action)
          ? (_openBlock(), _createBlock(CustomizerMiniButton, {
              key: 1,
              onClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(BlockLabelWithNamedArguments, { label: __props.action }, null, 8, ["label"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})